(function () {
  'use strict';

  function initRealRooms(root) {
    if (!root || root.dataset.rrInit === 'true') return;
    root.dataset.rrInit = 'true';

    var track = root.querySelector('[data-rr-track]');
    var lightbox = root.querySelector('[data-rr-lightbox]');
    if (!track || !lightbox) return;

    var triggers = Array.prototype.slice.call(track.querySelectorAll('[data-rr-open]'));
    if (!triggers.length) return;

    var scenes = triggers.map(function (trigger) {
      var img = trigger.querySelector('.rr__img');
      return {
        src: img ? (img.getAttribute('src') || '') : '',
        srcset: img ? (img.getAttribute('srcset') || '') : '',
        alt: img ? (img.getAttribute('alt') || '') : '',
        title: trigger.querySelector('.rr__title') ? trigger.querySelector('.rr__title').textContent : '',
        subtitle: trigger.querySelector('.rr__subtitle') ? trigger.querySelector('.rr__subtitle').textContent : ''
      };
    });

    var lightboxImg = lightbox.querySelector('[data-rr-lightbox-img]');
    var titleEl = lightbox.querySelector('[data-rr-lightbox-title]');
    var subtitleEl = lightbox.querySelector('[data-rr-lightbox-subtitle]');
    var closeEls = lightbox.querySelectorAll('[data-rr-close]');
    var prevBtn = lightbox.querySelector('[data-rr-prev]');
    var nextBtn = lightbox.querySelector('[data-rr-next]');

    var currentIndex = 0;
    var lastFocused = null;

    function render(index) {
      var scene = scenes[index];
      if (!scene) return;
      currentIndex = index;

      if (scene.srcset) {
        lightboxImg.setAttribute('srcset', scene.srcset);
      } else {
        lightboxImg.removeAttribute('srcset');
      }
      lightboxImg.setAttribute('src', scene.src);
      lightboxImg.setAttribute('alt', scene.alt);
      titleEl.textContent = scene.title;
      subtitleEl.textContent = scene.subtitle;
    }

    function open(index) {
      lastFocused = document.activeElement;
      render(index);
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      if (closeEls[0]) closeEls[0].focus();
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      lightbox.hidden = true;
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    function step(delta) {
      var next = (currentIndex + delta + scenes.length) % scenes.length;
      render(next);
    }

    function onKeydown(e) {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') step(1);
      if (e.key === 'ArrowLeft') step(-1);
    }

    triggers.forEach(function (trigger, i) {
      trigger.addEventListener('click', function () {
        open(i);
      });
    });

    Array.prototype.forEach.call(closeEls, function (el) {
      el.addEventListener('click', close);
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

    /* Basic swipe support inside the lightbox on touch devices */
    var touchStartX = null;
    var figure = lightbox.querySelector('.rr__lightbox-figure');
    if (figure) {
      figure.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].clientX;
      }, { passive: true });

      figure.addEventListener('touchend', function (e) {
        if (touchStartX === null) return;
        var deltaX = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(deltaX) > 40) {
          step(deltaX < 0 ? 1 : -1);
        }
        touchStartX = null;
      }, { passive: true });
    }

    /* Update the mobile scroll-position dots (purely decorative) */
    var dots = root.querySelectorAll('.rr__dot');
    if (dots.length && track) {
      var updateDots = function () {
        var items = track.querySelectorAll('.rr__item');
        if (!items.length) return;
        var trackRect = track.getBoundingClientRect();
        var closest = 0;
        var closestDist = Infinity;
        items.forEach(function (item, i) {
          var rect = item.getBoundingClientRect();
          var dist = Math.abs(rect.left - trackRect.left);
          if (dist < closestDist) {
            closestDist = dist;
            closest = i;
          }
        });
        var activeDot = Math.min(closest, dots.length - 1);
        dots.forEach(function (dot, i) {
          dot.style.opacity = i === activeDot ? '1' : '0.25';
        });
      };
      track.addEventListener('scroll', debounce(updateDots, 100), { passive: true });
      updateDots();
    }
  }

  function debounce(fn, wait) {
    var timeout;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(fn, wait);
    };
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-rr-section]');
    Array.prototype.forEach.call(sections, initRealRooms);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Re-init when the section is added/re-rendered in the theme editor */
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-rr-section]');
    if (section) initRealRooms(section);
  });
})();
